import { ActivityReason } from '@office-start/document-types';
import { useMemo } from 'react';
import { ActivityFilterKey } from '../models/ActivityFilters';
export function useActivityFilterMap(identity, msaUserHint) {
    return useMemo(function () {
        var activityFilterFunctionTuples = [
            !identity.isMsa
                ? [
                    ActivityFilterKey.created,
                    function (doc) {
                        var _a, _b;
                        return ((_a = doc.creatorUpn) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                            ((_b = identity.userPrincipalName) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                    },
                ]
                : [
                    ActivityFilterKey.created,
                    function (doc) {
                        var _a;
                        return ((_a = doc.driveId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                            (msaUserHint === null || msaUserHint === void 0 ? void 0 : msaUserHint.toLowerCase());
                    },
                ],
            !identity.isMsa
                ? [
                    ActivityFilterKey.mentions,
                    function (doc) {
                        return doc.recentActivities &&
                            doc.recentActivities.some(function (activity) {
                                var _a, _b;
                                return activity.reasonType ===
                                    ActivityReason.Mention &&
                                    activity.people.length &&
                                    ((_a = activity.people[0].upn) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                                        ((_b = identity.userPrincipalName) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                            });
                    },
                ]
                : undefined,
            !identity.isMsa
                ? [
                    ActivityFilterKey.edits,
                    function (doc) {
                        return doc.recentActivities &&
                            doc.recentActivities.some(function (activity) {
                                var _a;
                                return activity.reasonType === ActivityReason.Edit &&
                                    activity.actor &&
                                    activity.actor.upn &&
                                    activity.actor.upn.toLowerCase() ===
                                        ((_a = identity.userPrincipalName) === null || _a === void 0 ? void 0 : _a.toLowerCase());
                            });
                    },
                ]
                : undefined,
            !identity.isMsa
                ? [
                    ActivityFilterKey.comments,
                    function (doc) {
                        return doc.recentActivities &&
                            doc.recentActivities.some(function (activity) {
                                var _a;
                                return activity.reasonType ===
                                    ActivityReason.Comment &&
                                    activity.actor &&
                                    activity.actor.upn &&
                                    activity.actor.upn.toLowerCase() ===
                                        ((_a = identity.userPrincipalName) === null || _a === void 0 ? void 0 : _a.toLowerCase());
                            });
                    },
                ]
                : undefined,
            !identity.isMsa
                ? [
                    ActivityFilterKey.tasks,
                    function (doc) {
                        return doc.recentActivities &&
                            doc.recentActivities.some(function (activity) {
                                var _a, _b;
                                return activity.reasonType === ActivityReason.Task &&
                                    activity.people.length &&
                                    ((_a = activity.people[0].upn) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                                        ((_b = identity.userPrincipalName) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                            });
                    },
                ]
                : undefined,
            [ActivityFilterKey.hidden, function (doc) { return doc.isHidden; }],
        ].filter(function (tuple) { return !!tuple; });
        return new Map(activityFilterFunctionTuples);
    }, [identity.isMsa, identity.userPrincipalName, msaUserHint]);
}
//# sourceMappingURL=useActivityFilterMap.js.map